module.exports = __webpack_public_path__ + "img/1.98e57ea1.png";